function locationTypes(listing){
  thisDiv = document.createElement('div');
    listing.location_types.map(lc => {
    var locType = 'standardLocType'
    if(lc.includes('latinum')){
      var locType = 'platinumLocType' 
    }
    var locDiv = document.createElement('div')
    locDiv.innerText = lc
    if(Shopify.country == 'US' || Shopify.country == 'CA' || Shopify.country == 'BM' || Shopify.country == 'MX' ){
      let localeText = locDiv.innerText.replace("Authorised", "Authorized");
      locDiv.innerText = localeText;
         
    }
      
    locDiv.classList.add(locType);
    thisDiv.append(locDiv);
  })
  return thisDiv
};

function nearbyLocations(longitude, latitude) {
  var nearby = $("#nearby");
  fetch(
    "https://fb-locations-app-0259a1315fc1.herokuapp.com/locate.json?longitude=" +
      longitude +
      "&latitude=" +
      latitude
  )
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      var platinumCloseBy = false;
      if(data.closeby) {
        platinumCloseBy = true;
      }
      var suburb_title = 'you';
        if(data.suburb){
          suburb_title = data.suburb;
          var sub_title_html = document.getElementbyId('suburb_title');
          sub_title_html.innerHTML(suburb_title);
        } 
      // alert('!!!');
      if(platinumCloseBy) {
        $("#loader").hide();
        
      } else {
          $("#loader").hide();
      data.nearest.map((sweetItem) => {

        
        var platinum = '&nbsp;'
        var subtitle = '&nbsp;'
        if(sweetItem.title.split(' - ')[1]) {
          var subtitle = sweetItem.title.split(' - ')[1]
        }
        if(sweetItem.platinum == 'true') {
          var platinum = 'Platinum Partner'
        }
        var locDiv = document.createElement("div")
        var locTitleDiv = document.createElement("div")
        var locTitle = document.createElement("h3")
        var locSubTitle = document.createElement("h4")

        locDiv.classList.add('loc');
        locTitle.classList.add('locTitle');
        locSubTitle.classList.add('locSubtitle');
        locTitle.innerText = sweetItem.title.split(' - ')[0];
        locSubTitle.innerText = subtitle;

    
        var locLink = document.createElement('a')
        locLink.href = '/pages/locations/' + sweetItem.slug + '?view=nearby'
        locLink.classList.add('store-details-link');
        locLink.text = 'Store details > '
        var locTypes = locationTypes(sweetItem)

        locTitleDiv.append(locTitle, locSubTitle)
        locDiv.append(locTitleDiv, locTypes, locLink)
        nearby.append(locDiv);

        });
      }
    })
    .catch((error) => {
      // Handle any errors
      console.log("An error occurred:", error);
    });
}



function getSingleLocation() {
  console.log('Single Location Getter');
  var slug = $('#pageId').val();
  //alert(slug);
  // alert('!');
      // getUserLocation();

  fetch(
    "https://fb-locations-app-0259a1315fc1.herokuapp.com/locations/" +
      slug + '.json'
  )
    .then((response) => response.json())
    .then((sweetItem) => {
      console.log('DATA', sweetItem);

      contactButtons($('#locContactButtons'), sweetItem);
      socialSvgs($('#socialLinks'), sweetItem);
      var og_title = document.title;
      document.title = sweetItem.title + ' | ' + og_title ;
      var title = sweetItem.title.split(' - ')[0];
       var subtitle = '&nbsp;'
        if(sweetItem.title.split(' - ')[1]) {
          var subtitle = sweetItem.title.split(' - ')[1]
        }
        if(sweetItem.platinum == 'true') {
          var platinum = 'Platinum Partner'
        }
        var address = sweetItem.address
        $('#locAddress').innerHTML = '';
        address.split(',').map((address_line) => {
          $('#locAddress').append('<div>' + address_line + '</div>')
        });
        $('#locTitle').text(title);
        sweetItem.location_types.map((lc) => {
        if(Shopify.country == 'US' || Shopify.country == 'CA' || Shopify.country == 'BM' || Shopify.country == 'MX' ){
           $('#locTypes').append('<div class="locType">' + lc.replace("Authorised", "Authorized") + '</div>');
        } else {
          $('#locTypes').append('<div class="locType">' + lc + '</div>');
          
        }
        
      });
      $('#locSubtitle').text(subtitle);
      var isPlatinum = sweetItem.platinum;
      if(isPlatinum){
        $('#locPlatinum .platinum').css('display','block');
      } else {
        $('#locPlatinum .authorized').css('display','block');
      }
      var logo = sweetItem.logo_image_url
      
      $('#locContact h3').show();
      $('#locDescription').html(sweetItem.feed_description.body);
      var descriptionTitle = document.createElement('h2');
      descriptionTitle.classList.add('tablet-and-up');
      descriptionTitle.innerHTML = title;
      var mobileDescriptionTitle = descriptionTitle.cloneNode(true)
      
      $('#locDescription').append('<a href="/pages/locations" class="backLink">Return to locations ></a>');
      mobileDescriptionTitle.classList.remove('tablet-and-up');
      mobileDescriptionTitle.classList.add('phone-only');
      if(logo){ 
        $('#locLogo img').attr('src', sweetItem.logo_image_url);
      } else {
        $('#locTypes').prepend(mobileDescriptionTitle);
        $('#locDescription').prepend(descriptionTitle);
        $('#locLogo').hide();
      }
    });
   
}

function getMap(longitude, latitude) {
  console.log('Map');
  var isNearby = $("#nearby").length;
  if(isNearby){ 
    nearbyLocations(longitude, latitude);
  } else {
    getSingleLocation();
  }
}

function getUserLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(showPosition, showError);
  } else {
    alert("Geolocation is not supported by this browser.");
  }
}

function showPosition(position) {
  var latitude = position.coords.latitude;
  var longitude = position.coords.longitude;
  getMap(longitude, latitude);
}

function useIP(){
  $.getJSON("https://api.ipify.org?format=json", function (data) {
        $.getJSON(
          "https://ip-geolocation.whoisxmlapi.com/api/v1?apiKey=at_szmUV2cxyBgGLD9Ga0hSWu9807TQB&ipAddress=" +
            data.ip,
          function (data2) {
            getMap(data2["location"]["lng"], data2["location"]["lat"]);
          }
        );
      });
}

function contactButtons(container, listing) {
  container.empty()
   listing.contacts.map((contact) => {
      var mailto = ''
      if(contact.type == 'Email'){ 
        var mailto = 'mailto:'
      }
     var button = '<div class=\"locButton\"><a target=\"_blank\" href=\"' +  mailto + contact.url + '\">' + contact.type + '</a></div>';
     container.append(button) 
   })
}

function socialLinks(container, listing) {
  container.empty();
  listing.socials.map((social) => {
      var mailto = ''
        if(social.type.includes('mail')){ 
          var mailto = 'mailto:'
        }
      var button = '<div class=\"socIcon\"><a target=\"_blank\" href=\"' + mailto + social.url + '\"><img src=\"' + grabAssetUrl(`location-${social.type}_icon.png`) + '" /></a></div>';
     container.append(button) 
  } )
}

function socialSvgs(container, listing) {
  container.empty();
  listing.socials.map((social) => {
      var button = social.icon;
     container.append(button) 
  } )
}

function grabAssetUrl(asset_name){
  var url = $('input#assetUrl').val()
  var new_url = url.replace('social.png', asset_name)
  return new_url
}


function showError(error) {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      console.log("User denied the request for Geolocation.");
      useIP();
      break;
    case error.POSITION_UNAVAILABLE:
      console.log("Location information is unavailable.");
      useIP();
      break;
    case error.TIMEOUT:
      alert("The request to get user location timed out.");
      useIP();
      break;
    case error.UNKNOWN_ERROR:
      alert("An unknown error occurred.");
      useIP();
      break;
  }
}

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

window.onload = function () {
  var isLocationPage = $("#locationPage").length;
  var isNearbyPage = $("#nearby-block").length;
  if(isLocationPage || isNearbyPage) {
    console.log('---// getUserLocation //---');
    getUserLocation();
    console.log('---// getSingleLocation //---');
    // getSingleLocation();
  }
};